import React from "react";
import InputBase from "./InputBase";
import Format from "../../common/Format";
import Convert from "../../common/Convert";
import {
    Input,
    Row, Col, Label
} from "reactstrap"

export default class InputNumber extends InputBase {
    static defaultProps = {
        label:'数値',
        labelOn:false,
        emptyLabel: false,
        name:'',
        className:'',
        style:{},
        maxlength : 1024,
        multiline: false,
        enterSearchFlag: false,
        unit:'',
        rootData:{
            values:{},
            errors:{},
            requiredData:{}
        }
    }
    constructor(props) {
        super(props);
        this.handle_blur = this.handle_blur.bind(this);
        this.enterSearch = this.enterSearch.bind(this);
    }

    enterSearch(e){
        var ENTER = 13;
        if(this.props.enterSearchFlag == false){
            if (e.keyCode == ENTER) {
                super.focusNextNode(e);
            }
            return
        }
        
        if (e.keyCode == ENTER) {
            const formattedValue = Format.format_number(Format.format_hankaku(e.target.value))
            e.target.value = formattedValue
            this.props.enterCallback&&this.validate(formattedValue, this.props.enterCallback)
        }        
    }

    componentDidMount(){
        document.getElementById(this.props.name).touch=()=>{
            const value = this.selfDom.current.props.defaultValue
            this.handle_blur({target:{value:(value!==null && value!==undefined ? String(value):"")}})
        }
    }

    handle_blur(e) {
        const maxLength = 10;
        const formattedValue = Format.format_number(Format.format_hankaku(e.target.value.slice(0, maxLength)))

        e.target.value = formattedValue;
        this.validate(formattedValue)
    }

    render() {
        const{
            onChangeCallback,
            disabled=false,
            name,
            label,
            unit,
            className,
            rootData:{
                errors,
                requiredData,
                values
            },
            maximum,
            minimum,
            labelOn,
            emptyLabel,
            size = 6,
            value,
            showValidateMessage=true
        } = this.props

        const columnObject = Convert.key_split(name)
        const defaultValue = (value !== undefined) ? value : (values&&values[columnObject.column])
        const validate_message = errors&&errors[columnObject.column]
        
        return (
            <>
                {
                    (labelOn) &&
                    <Row>
                        <Col>
                            <Label for={name} className="search-text-order">
                                {emptyLabel ? '　' : label + '：'}
                            </Label>
                        </Col>
                    </Row>
                }
                <Row>
                    <Col md={unit ? (size-2) : size} style={unit ? {paddingRight:0} : {paddingRight:15}}>
                        <Input type={disabled?"text":"number"}
                        onWheel={(e)=>{e.target.blur()}}
                        autoComplete="off"
                        ref={this.selfDom}
                        disabled={disabled} 
                        name={name} 
                        className={`${className} tabable`} 
                        onKeyDown={(e) => this.enterSearch(e)}
                        id={name}
                        placeholder={label + "を入力してください"} 
                        onBlur={this.handle_blur} 
                        defaultValue={defaultValue}
                        {...(onChangeCallback?{onChange:onChangeCallback}:{})}
                        {...(maximum?{max:maximum}:{})}
                        {...(minimum?{min:minimum}:{})}
                        {...(!showValidateMessage && validate_message instanceof Array && validate_message.length>0 
                            && {style:{border:"2px solid red"}})}
                        />
                        {defaultValue!=undefined&&!disabled&&defaultValue!==""&&<svg 
                            style={{
                                position: "absolute",
                                right: "12px",
                                top: 0,
                                height: "calc(2.25rem + 2px)",
                            }}
                            height="20" 
                            width="20" 
                            viewBox="0 0 20 20" 
                            aria-hidden="true" 
                            focusable="false" 
                            className="css-6q0nyr-Svg text-clear-btn"
                            onClick={()=>{this.validate(null)}}
                        >
                            <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path>
                        </svg>}
                    </Col>
                    {unit && 
                        <Col md="2" style={{paddingLeft:0}}>
                            <span style={{height: '100%'}} 
                            className='d-flex align-items-end'>
                                {unit}
                            </span>
                        </Col>
                    }
                </Row>
                {
                    showValidateMessage && validate_message instanceof Array && validate_message.length>0 &&
                    <p id={name} style={{ color: "red" }}>{validate_message.length>0?validate_message[0]:validate_message}</p>
                }
            </>
        );
    }
}
